 
import React, { useEffect } from 'react'
import { useNavigate,Navigate,useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PrivateRoute ({roleAllowed,Comp}) {
 const loc=useLocation();

 const userRole=useSelector((state)=>state.globalData.role);

  return (
          userRole.find(role=>roleAllowed?.includes(role))?<Comp/>
          :
          userRole
          ?<Navigate to="/notAllowed" state={{from:loc}} replace />
          :<Navigate to="/login" state={{from:loc}} replace />
  )
}

export default PrivateRoute
